import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {sidebarMenu_template} from "../templates/sidebarMenu_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class propertyManagement_template extends vnTemplate{

    protected sidebarMenu: sidebarMenu_template;
    protected presetFilter: presetFilter_template;
    protected searchField: filterSimple_template;
    protected statusTooltip: infoButton_template;

    protected getTemplateHtml(): string{

        return `

        <div class="page-header">
            <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
            <h2 style="display: none;" class="title-page">Usage Stats</h2>
        </div>

        <div class="nav-page-container">
            <div class="nav-page-grid">
                <div class="nav-page-sidebar">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>
                <div id="propertyManagement-results" class="nav-page-content">
                    <div class="block-default variation">
                        <div class="w-justify full-width">
                            <div class="w-left w-form">
                                <div class="form-body form-body-header">
                                    <div class="form-group">
                                        <span class="form-sub-title">
                                            Property Management
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <p class="form-text">
                                            Manage your account's properties
                                        </p>
                                    </div>
                                    <div class="form-group">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="list-results-header w-justify">
                        <div class="w-left">
                            <button type="button" data-bind="click: onOpenCreate" class="button-default icon i-add-2"><span>Add Property</span></button>
                        </div>

                        <div class="w-center">
                            `+ this.searchField.getHtmlBuild() + `
                        </div>

                        <div class="w-right">

                        </div>
                    </div>

                    <div class="w-list-results taller">
                        <table class="list-results list-sections">
                            <thead>
                                <tr>
                                    <th><span>Property Name</span></th>
                                    <th><span>Property Short Name</span></th>
                                    <th><span>Domain</span></th>
                                    <th><span>Property Id</span></th>
                                    <th style="display: flex;">
                                        <span>Status</span>
                                        <div class="w-tooltips-adv auto-height short pos-center-bottom">
                                            ${this.statusTooltip.getHtmlBuild()}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- ko if: properties().length > 0 -->
                                    <!-- ko foreach: properties -->
                                        <tr class="cursor" data-bind="click: function() { $parent.onOpenEdit($data) }">
                                            <td><span data-bind="text: name"></span></td>
                                            <td><span data-bind="text: shortName"></span></td>
                                            <td><span data-bind="text: domain"></span></td>
                                            <td><span data-bind="text: reference"></span></td>
                                            <td><span data-bind="text: isActive ? 'Active' : 'Inactive'"></span></td>
                                        </tr>
                                    <!-- /ko -->
                                <!-- /ko -->
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
        <footer class="default-footer">
            <span class="logo-short"></span>
            <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
            <span>|</span>
            <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </footer>

        <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isCreateOpen()}">
            <div class="lightbox-content">

                <div class="w-form lightbox-form">
                    <div class="form-header">
                        <h3 class="form-title">Create Property</h3>
                        <button type="button" data-bind="event: { click: onCloseCreate }" class="close-button icon i-close-2"></button>
                    </div>

                    <div class="form-body">

                        <div class="form-group" data-bind="css: {'is-error' : propertyNameError()}">
                            <label class="form-label">Property Name</label>
                            <div class="w-input">
                                <input data-bind="value: create_propertyName" type="text" name="propertyName" id="propertyName" class="input-text">
                            </div>
                            <span class="form-error" data-bind="text: propertyNameError()"></span>
                        </div>

                        <div class="form-group" data-bind="css: {'is-error' : propertyShortNameError()}">
                            <label class="form-label">Property Short Name</label>
                            <div class="w-input">
                                <input style="text-transform: uppercase;" data-bind="value: create_propertyShortName" type="text" name="propertyShortName" id="propertyShortName" class="input-text">
                            </div>
                            <span class="form-error" data-bind="text: propertyShortNameError()"></span>
                        </div>

                        <div class="form-group" data-bind="css: {'is-error' : propertyDomainError()}">
                            <label class="form-label">Domain Name</label>
                            <div class="w-input">
                                <input data-bind="value: create_propertyDomain" type="text" name="propertyDomain" id="propertyDomain" class="input-text">
                            </div>
                            <span class="form-error" data-bind="text: propertyDomainError()"></span>
                        </div>
                    </div>

                    <div class="form-footer">
                        <button data-bind="click: onCloseCreate" type="button" class="btn">Cancel</button>
                        <button data-bind="click: onSubmitCreate, disable: disabledCreate()" type="button" class="btn highlight">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ko if: selectedProperty -->
            <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isEditOpen() && selectedProperty()}">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Edit property</h3>
                            <button type="button" data-bind="event: { click: onCloseEdit }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group" data-bind="css: {'is-error' : propertyNameError()}">
                                <label class="form-label">Property Name</label>
                                <div class="w-input">
                                    <input data-bind="value: edit_propertyName" type="text" name="propertyName" id="propertyName" class="input-text">
                                </div>
                                <span class="form-error" data-bind="text: propertyNameError()"></span>
                            </div>
                            <div class="form-group" data-bind="css: {'is-error' : propertyShortNameError()}">
                                <label class="form-label">Property Short Name</label>
                                <div class="w-input">
                                    <input style="text-transform: uppercase;" data-bind="value: edit_propertyShortName" type="text" name="propertyShortName" id="propertyShortName" class="input-text">
                                </div>
                                <span class="form-error" data-bind="text: propertyShortNameError()"></span>
                            </div>
                            <div class="form-group" data-bind="css: {'is-error' : propertyDomainError()}">
                                <label class="form-label">Domain Name</label>
                                <div class="w-input">
                                    <input data-bind="value: edit_propertyDomain" type="text" name="propertyDomain" id="propertyDomain" class="input-text">
                                </div>
                                <span class="form-error" data-bind="text: propertyDomainError()"></span>
                            </div>
                            <div class="form-group">
                                <input id="is-active" type="checkbox" data-bind="checked: edit_propertyDomainIsActive">
                                <label for="is-active" class="form-label icon i-check" style="line-height: 1;">Active</label>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="click: onCloseEdit" type="button" class="btn">Cancel</button>
                            <button data-bind="click: onSubmitEdit, disable: disabledEdit()" type="button" class="btn highlight">Save</button>
                        </div>
                    </div>

                </div>
            </div>
        <!-- /ko -->
        `;
    }

    protected initPartial(): void {

        this.searchField = new filterSimple_template("searchField", this.getTemplateViewModel(), this.caller);

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('propertyManagement');

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('property-management');

        let statusTooltipContent = `
            <p>Properties marked as <b>Inactive</b> will not be tracked and no data will be collected during this period.</p>`;
        this.statusTooltip = new infoButton_template('statusTooltip', this.getTemplateViewModel(), this.caller)
        this.statusTooltip.setContent(statusTooltipContent);
    }

    protected getTemplateName(): string{

        return "propertyManagement-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            properties: ko.observableArray([]),
            selectedProperty: ko.observable(null),
            isCreateOpen: ko.observable(false),
            isEditOpen: ko.observable(false),
            create_propertyName: ko.observable(''),
            create_propertyShortName: ko.observable(''),
            create_propertyDomain: ko.observable(''),
            edit_propertyId: ko.observable(null),
            edit_propertyName: ko.observable(''),
            edit_propertyShortName: ko.observable(''),
            edit_propertyDomain: ko.observable(''),
            edit_propertyDomainIsActive: ko.observable(1),
            disabledEdit: ko.observable(false),
            propertyNameError: ko.observable(false),
            propertyShortNameError: ko.observable(false),
            propertyDomainError: ko.observable(false),
            openSidebar: function(){
                self.openSidebar();
            },
            onOpenCreate: function() {

                self.onOpenCreate();
            },
            onCloseCreate: function(){

                self.onCloseCreate();
            },
            onSubmitCreate(){
                self.onSubmitCreate();
            },
            disabledCreate(){

                return self.disabledCreate();
            },
            onOpenEdit: function(property){
                self.onOpenEdit(property);
            },
            onSubmitEdit(){
                self.onSubmitEdit();
            },
            onCloseEdit: function(){
                self.onCloseEdit();
            }
        };
    }

    public setProperties(properties){

        this.getTemplateViewModel().properties(properties);
    }

    public setErrors(errors){

        this.clearErrors();

        const errorMsgs = errors.reduce((acc, error) => {
            acc[error.label] = error.messages.join(' ');
            return acc;
        }, {});

        if(errorMsgs['Property Name']) {

            this.getTemplateViewModel().propertyNameError(errorMsgs['Property Name']);
        }

        if(errorMsgs['Property Short Name']) {

            this.getTemplateViewModel().propertyShortNameError(errorMsgs['Property Short Name']);
        }

        if(errorMsgs['Property Domain']) {

            this.getTemplateViewModel().propertyDomainError(errorMsgs['Property Domain']);
        }
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    private onOpenCreate() {

        this.getTemplateViewModel().isCreateOpen(true);
    }

    private onCloseCreate() {

        this.getTemplateViewModel().create_propertyName('')
        this.getTemplateViewModel().create_propertyShortName('');
        this.getTemplateViewModel().create_propertyDomain('');
        this.getTemplateViewModel().isCreateOpen(false);
        this.clearErrors();
    }

    private onSubmitCreate(){

        this.caller.onSubmitCreate();
    }

    private disabledCreate() {

        /* const name = this.getTemplateViewModel().create_propertyName();
        const category = this.getTemplateViewModel().create_category();

        return (!name || name == '' || !category || category == ''); */
    }

    private onOpenEdit(property) {

        this.getTemplateViewModel().selectedProperty(property);
        this.getTemplateViewModel().edit_propertyId(property.id);
        this.getTemplateViewModel().edit_propertyName(property.name);
        this.getTemplateViewModel().edit_propertyShortName(property.shortName);
        this.getTemplateViewModel().edit_propertyDomain(property.domain);
        this.getTemplateViewModel().edit_propertyDomainIsActive(property.isActive);

        this.getTemplateViewModel().isEditOpen(true);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    private onCloseEdit() {

        this.getTemplateViewModel().selectedProperty(null);
        this.getTemplateViewModel().edit_propertyId(null)
        this.getTemplateViewModel().edit_propertyName('')
        this.getTemplateViewModel().edit_propertyShortName('');
        this.getTemplateViewModel().edit_propertyDomain('');
        this.getTemplateViewModel().edit_propertyDomainIsActive(1);
        this.getTemplateViewModel().isEditOpen(false);
        this.clearErrors();
    }

    private onSubmitEdit() {

        this.caller.onSubmitEdit();
    }

    private clearErrors() {

        this.getTemplateViewModel().propertyNameError(false);
        this.getTemplateViewModel().propertyShortNameError(false);
        this.getTemplateViewModel().propertyDomainError(false);
    }

    public setFieldsOnSuccess() {

        this.getTemplateViewModel().create_propertyName('')
        this.getTemplateViewModel().create_propertyShortName('');
        this.getTemplateViewModel().create_propertyDomain('');
        this.getTemplateViewModel().isCreateOpen(false);

        this.getTemplateViewModel().selectedProperty(null);
        this.getTemplateViewModel().edit_propertyId(null)
        this.getTemplateViewModel().edit_propertyName('')
        this.getTemplateViewModel().edit_propertyShortName('');
        this.getTemplateViewModel().edit_propertyDomain('');
        this.getTemplateViewModel().edit_propertyDomainIsActive(1);
        this.getTemplateViewModel().isEditOpen(false);

        this.clearErrors();
    }

    //
    // implementation of base class [vnTemplate] billingPeriodId
    public getViewModelForRequest(){

        return {

            filters:{

                create_propertyName: this.getTemplateViewModel().create_propertyName(),
                create_propertyShortName: this.getTemplateViewModel().create_propertyShortName(),
                create_propertyDomain: this.getTemplateViewModel().create_propertyDomain(),

                edit_propertyId: this.getTemplateViewModel().edit_propertyId(),
                edit_propertyName: this.getTemplateViewModel().edit_propertyName(),
                edit_propertyShortName: this.getTemplateViewModel().edit_propertyShortName(),
                edit_propertyDomain: this.getTemplateViewModel().edit_propertyDomain(),
                edit_propertyDomainIsActive: this.getTemplateViewModel().edit_propertyDomainIsActive() ? 1 : 0,

                search: this.getTemplateViewModel().searchField.filterKeyword()
            }
        }
    }

    public setViewModelFromRequest(params : Array<any>): void{


    }

}


// WEBPACK FOOTER //
// ./js/components/templates/propertyManagement_template.ts